<template>
  <div class="shadow rounded-1">
    <div class="d-inline-block float-end">
      <select
        id="provinsiBulan"
        v-model="bulan"
        class="form-select"
        @change="selectBulan"
      >
        <option value="">Semua Bulan</option>
        <option v-for="d in monthOptions" :value="d.value">
          {{ d.label }}
        </option>
      </select>
    </div>
    <h2 class="text-center pt-3">Jumlah Permohonan per Provinsi</h2>
    <apexchart
      type="bar"
      height="450"
      :options="chartOptions"
      :series="series"
    ></apexchart>
  </div>
</template>

<script>
import axios from 'axios'
import VueApexCharts from 'vue-apexcharts'

export default {
  components: {
    apexchart: VueApexCharts,
  },
  props: ['tahun'],
  data() {
    return {
      baseapi: localStorage.getItem('baseapi'),
      user: JSON.parse(localStorage.getItem('user')),
      bulan: '',
      monthOptions: [
        { value: '1', label: 'Jan' },
        { value: '2', label: 'Feb' },
        { value: '3', label: 'Mar' },
        { value: '4', label: 'Apr' },
        { value: '5', label: 'Mei' },
        { value: '6', label: 'Jun' },
        { value: '7', label: 'Jul' },
        { value: '8', label: 'Agu' },
        { value: '9', label: 'Sep' },
        { value: '10', label: 'Okt' },
        { value: '11', label: 'Nov' },
        { value: '12', label: 'Des' },
      ],
      series: [
        {
          name: 'Berusaha',
          data: [0],
        },
        {
          name: 'Nonberusaha',
          data: [0],
        },
      ],
      chartOptions: {
        chart: {
          stacked: true,
          toolbar: {
            show: true,
          },
        },
        plotOptions: {
          bar: {
            columnWidth: '80%',
            horizontal: false,
            dataLabels: {
              total: {
                enabled: true,
                style: {
                  color: '#777777',
                },
              },
            },
          },
        },
        colors: ['#008FFB', '#FEB019'],
        dataLabels: {
          enabled: false,
        },
        xaxis: {
          categories: [''],
          labels: {
            minHeight: 150,
          },
        },
        yaxis: {
          axisBorder: {
            show: false,
          },
          axisTicks: {
            show: false,
          },
          labels: {
            style: {
              colors: '#78909c',
            },
          },
        },
        responsive: [
          {
            breakpoint: 480,
            options: {
              legend: {
                position: 'bottom',
                offsetX: -10,
                offsetY: 0,
              },
            },
          },
        ],
      },
    }
  },
  methods: {
    selectBulan() {
      this.loadDataChart()
    },
    async loadDataChart() {
      try {
        let url =
          `api/dashboard/getJumlahPermohonanProvinsiBulan?tahun=${this.tahun}` +
          `${this.bulan ? `&bulan=${this.bulan}` : ''}`

        const res = await axios.get(this.baseapi + url, {
          headers: {
            Authorization: `Bearer ` + this.user.accessToken,
          },
        })

        const data = res.data.data
        this.series = data.series.map((d) => ({
          name: d.name,
          data: d.series,
        }))
        this.chartOptions = {
          ...this.chartOptions,
          xaxis: {
            categories: [...data.categories],
          },
        }
      } catch (error) {}
    },
  },
  watch: {
    tahun: {
      handler(val) {
        this.loadDataChart()
      },
      immediate: true,
    },
  },
}
</script>
